<template>
  <v-col class="mx-4">
    <div class="d-flex">
      <div
        class="text-h6 py-0 my-0 pl-0"
        style="color: #23468c; font-weight: 500"
      >
        Outbound {{ editable ? "Edit" : "Upload" }}
      </div>
    </div>
    <v-divider class="mt-1 mb-4"></v-divider>
    <v-card>
      <v-card-title>
        <span class="body-1 font-weight-bold"
          >{{ editable ? "Edit" : "Upload" }} Order

          <i class="caption red--text ml-4"> * required field</i>
        </span>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pb-0 pt-0">
        <v-form v-if="!editable">
          <ul class="text-left mb-2">
            <li>Order Reference Number has to be unique.</li>
            <li>Order Quantity should be full integer number.</li>
          </ul>
        </v-form>
        <v-form v-else>
          <ul class="text-left mb-2">
            <li v-for="(item, j) in help_text" :key="j">{{ item }}</li>
          </ul>
        </v-form>
      </v-card-text>
      <v-divider class="mb-3"></v-divider>
      <v-card-text class="pb-0 pl-1">
        <v-form ref="form">
          <div class="text-center py-0">
            <!-- <v-row no-gutters>
              <v-col md="6" class="pl-3">
                <v-text-field
                  outlined
                  v-model="name"
                  class="required"
                  label="Customer Name"
                  :rules="[
                    (v) =>
                      new RegExp('[a-zA-Z]').test(v) ||
                      'Customer Name should contain at least 1 alphabet.',
                    (v) =>
                      (!!v && v.length > 0) ||
                      'Customer Name is required and should contain at least 1 character.',
                  ]"
                ></v-text-field>
              </v-col>
              <v-col md="6" class="pl-3">
                <v-text-field
                  outlined
                  v-model="phone"
                  class="required"
                  type="text"
                  label="Customer Phone"
                  :rules="[
                    (v) => (v && !!v.trim()) || 'Phone Number is required',
                    (v) =>
                      /^\s*(?:\+?\d{1,3})?[-. (]*\d{1,9}[-. )]*\s*$/.test(v) ||
                      'Phone number must be valid',
                  ]"
                ></v-text-field>
              </v-col>
              <v-col md="6" class="pl-3">
                <v-text-field
                  outlined
                  v-model="email"
                  maxlength="100"
                  :rules="[
                    (v) =>
                      (v && v.trim().length > 0) || 'Email Address is required',
                    (v) =>
                      (!!v && /^[^@\s]+@.+\..+$/.test(v)) ||
                      'E-mail must be valid',
                    (v) =>
                      !v.includes(' ') || 'No spaces allowed in email address',
                  ]"
                  class="required"
                  @keydown.space.prevent
                  label="Customer Email"
                ></v-text-field>
              </v-col>
              <v-col md="6" class="pl-3">
                <v-text-field
                  outlined
                  v-model="address1"
                  class="required"
                  label="Address Line 1"
                  maxlength="90"
                  :rules="[
                    (v) =>
                      !!v.trim().replace(/[^a-zA-Z0-9]/g, '').length ||
                      'Address Line 1 is required',
                  ]"
                ></v-text-field>
              </v-col>
              <v-col md="6" class="pl-3">
                <v-text-field
                  outlined
                  v-model="address2"
                  label="Address Line 2"
                  hide-details
                  maxlength="90"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-divider class="mb-4 mt-4"></v-divider> -->
            <v-row no-gutters>
              <v-col md="6" class="pl-3 pb-0" v-if="!editable">
                <v-autocomplete
                  v-model="warehouse"
                  :items="warehouses"
                  item-text="name"
                  dense
                  item-value="id"
                  label="Select Warehouse"
                  placeholder="Start typing to Search"
                  class="pt-0 text-center required"
                  :rules="[(v) => !!v || 'Please Select Warehouse']"
                  outlined
                  @change="
                    getStores(selectedClient, warehouse), fetchClientList()
                  "
                ></v-autocomplete>
              </v-col>
              <v-col md="4" class="pl-3" v-else>
                <v-text-field
                  outlined
                  dense
                  v-model="warehouse_name"
                  label="Warehouse"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col
                md="6"
                v-if="
                  (userCategory.user_category === 3 ||
                    userCategory.user_category === 6) &&
                  !editable
                "
                class="pl-3 pb-0"
              >
                <v-autocomplete
                  v-model="selectedClient"
                  :items="clients"
                  :loading="clientLoader"
                  hide-no-data
                  item-text="name"
                  item-value="id"
                  label="Select Client"
                  placeholder="Start typing to Search"
                  class="pt-0 text-center required"
                  :rules="[(v) => !!v || 'Please Select Client']"
                  outlined
                  dense
                  @change="getStores(selectedClient, warehouse)"
                ></v-autocomplete>
              </v-col>
              <v-col
                md="4"
                class="pl-3"
                v-if="
                  (userCategory.user_category === 3 ||
                    userCategory.user_category === 6) &&
                  editable
                "
              >
                <v-text-field
                  outlined
                  dense
                  v-model="client_name"
                  label="Client"
                  disabled
                ></v-text-field>
              </v-col>
              <v-col md="6" class="pb-0 pl-3" v-if="!editable">
                <v-autocomplete
                  v-model="infor_storer_id"
                  label="Storer Name"
                  :rules="[(v) => !!v || 'Storer Name is required.']"
                  item-text="channel_name"
                  item-value="id"
                  class="required"
                  :items="stores"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>
              <v-col md="4" class="pl-3" v-else>
                <v-text-field
                  outlined
                  dense
                  v-model="storer_name"
                  label="Storer"
                  disabled
                ></v-text-field>
              </v-col>

              <v-col :md="editable ? 4 : 6" class="pl-3">
                <v-text-field
                  outlined
                  v-model="order_no"
                  class="required"
                  label="Order Number"
                  :rules="[
                    (v) =>
                      (!!v && /^[a-zA-Z0-9/ _:-]+$/.test(v)) ||
                      'Order Number accepts only A-Z, a-z, 0-9, / _ - : only.',
                  ]"
                  hide-details="auto"
                  :disabled="editable"
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" class="pl-3" v-if="!editable">
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  @update:return-value="(val) => (date = val || date)"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(date)"
                      label="Delivery Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                      outlined
                      class="required"
                      :rules="[(v) => !!v || 'Please Select  Delivery Date']"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    @input="dateMenu = false"
                    :min="getStartDate"
                    :reactive="false"
                    v-if="dateMenu"
                    :initial-active-month="() => new Date()"
                  ></v-date-picker>
                </v-menu>
              </v-col>

              <v-col md="6" class="pb-0 pl-3" v-if="!editable">
                <v-autocomplete
                  v-model="allocation_filter"
                  label="Allocation Filter"
                  :rules="[(v) => !!v || 'Allocation Filter required.']"
                  item-text="text"
                  item-value="value"
                  class="required"
                  :items="allocationfilters"
                  outlined
                  dense
                  @change="getTemplate(allocation_filter)"
                ></v-autocomplete>
              </v-col>
              <v-col md="4" class="pl-3" v-else>
                <v-text-field
                  outlined
                  v-model="allocation_filter_show"
                  label="Allocation Filter"
                  hide-details="auto"
                  disabled
                  dense
                ></v-text-field>
              </v-col>
              <v-col md="6" class="custom" v-if="!editable">
                <v-file-input
                  v-model="file"
                  counter
                  show-size
                  accept=".xlsx"
                  class="required pl-3"
                  prepend-icon=""
                  prepend-inner-icon="mdi-paperclip"
                  label="Select your Order File"
                  outlined
                  dense
                  :rules="[(v) => !!v || 'Please Select Order File']"
                >
                </v-file-input>
              </v-col>
            </v-row>
            <v-divider class="mx-3 mt-2" v-if="editable"></v-divider>
            <v-row v-if="editable" class="mx-3 pl-0 my-0">
              <v-data-table
                :headers="headers"
                :items="OutboundOrder"
                class="elevation-1 custom-icon-size mr-2 mt-4"
                disable-pagination
                hide-default-footer
                v-if="OutboundOrder && OutboundOrder.length"
              >
                <template v-slot:[`item.mfg_date`]="{ item }">
                  <span v-if="item.mfg_date">{{
                    item.mfg_date | localMomentNew | moment("DD MMM, YYYY")
                  }}</span>
                </template>

                <template v-slot:[`item.expiry_date`]="{ item }">
                  <span v-if="item.expiry_date">{{
                    item.expiry_date | localMomentNew | moment("DD MMM, YYYY")
                  }}</span>
                </template>
                <template v-slot:[`item.created_at`]="{ item }">
                  <span v-if="item.created_at">{{
                    item.created_at
                      | uaeDateTime
                      | moment("DD MMM, YYYY hh:mm A")
                  }}</span>
                  <br /><span v-if="item.created_by"
                    >({{ item.created_by }})</span
                  >
                </template>
                <template v-slot:[`item.updated_at`]="{ item }">
                  <span v-if="item.updated_at">{{
                    item.updated_at
                      | uaeDateTime
                      | moment("DD MMM, YYYY hh:mm A")
                  }}</span>
                </template>
              </v-data-table>
              <v-divider></v-divider>
            </v-row>
            <v-row class="mx-1">
              <v-col cols="12" sm="6" class="" v-if="editable">
                <v-menu
                  v-model="dateMenu"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                  @update:return-value="(val) => (date = val || date)"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :value="getFormattedDate(date)"
                      label="Delivery Date"
                      append-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      dense
                      outlined
                      class="required"
                      :rules="[(v) => !!v || 'Please Select  Delivery Date']"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date"
                    @input="dateMenu = false"
                    :min="getStartDate"
                    :reactive="false"
                    v-if="dateMenu"
                    :initial-active-month="() => new Date()"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col md="6" class="custom" v-if="editable">
                <v-file-input
                  v-model="file"
                  counter
                  show-size
                  accept=".xlsx"
                  class="pl-0"
                  prepend-icon=""
                  prepend-inner-icon="mdi-paperclip"
                  label="Select your Order File"
                  outlined
                  dense
                >
                </v-file-input>
              </v-col>
            </v-row>
            <v-row class="text-left mt-0">
              <v-col class="pl-6">
                <v-btn
                  color="green"
                  dark
                  class="mr-3"
                  @click="listPage"
                  v-if="checkPermission('app_ecom_vendors:excel_details')"
                >
                  Uploaded List
                </v-btn>
                <v-btn
                  color="primary"
                  dark
                  :loading="fileLoader"
                  @click="upload"
                  v-if="!errorFound"
                >
                  Upload
                </v-btn>
                <v-btn :disabled="true" class="readonly-button" v-else>
                  Upload
                </v-btn>

                <v-btn
                  color="info"
                  class="ml-3"
                  :loading="downloader"
                  v-if="newTemplate"
                  @click="downloadTemplate()"
                  >Download template</v-btn
                >

                <v-btn class="ml-3" @click="close()"> Cancel </v-btn>
              </v-col>
            </v-row>
          </div>
        </v-form>
      </v-card-text>
    </v-card>
  </v-col>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  components: {},
  computed: {
    ...mapGetters(["userRole", "userCategory"]),
    getStartDate() {
      var startDate = new Date();
      startDate.setDate(startDate.getDate() + 1);
      startDate.setHours(0, 0, 0, 0);
      return startDate.toISOString().split("T")[0];
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.fetchClientList();
    });
    if (this.value == "") {
      this.value = this.userCategory.user_category;
    }
  },
  data() {
    return {
      OutboundOrder: [],
      headers: [
        {
          text: "SKU",
          value: "sku",
          class: "body-1 font-weight-bold",
          align: "left",
          sortable: false,
          width: 150,
        },

        {
          text: "External Line No",
          value: "externlineno",
          class: "body-1 font-weight-bold",
          align: "left",
          sortable: false,
          width: "100px",
        },

        {
          text: "UOM",
          value: "uom",
          class: "body-1 font-weight-bold",
          align: "left",
          sortable: false,
        },
        {
          text: "Allocation Strategy",
          value: "allocation_strategy",
          class: "body-1 font-weight-bold",
          align: "left",
          sortable: false,
        },

        {
          text: "Unit Price",
          value: "unit_price",
          class: "body-1 font-weight-bold",
          align: "left",
          sortable: false,
        },
        {
          text: "LPN",
          value: "lpn",
          class: "body-1 font-weight-bold",
          align: "left",
          sortable: false,
        },
        {
          text: "Open Qty",
          value: "open_qty",
          class: "body-1 font-weight-bold",
          align: "left",
          sortable: false,
        },
        {
          text: "Pack",
          value: "pack",
          class: "body-1 font-weight-bold",
          align: "left",
          sortable: false,
          width: "100px",
        },
        {
          text: "Line",
          value: "line",
          class: "body-1 font-weight-bold",
          align: "left",
          sortable: false,
          width: "100px",
        },

        {
          text: "MFG Date",
          value: "mfg_date",
          class: "body-1 font-weight-bold",
          align: "left",
          width: 150,
          sortable: false,
        },
        {
          text: "Expiry Date",
          value: "expiry_date",
          class: "body-1 font-weight-bold",
          align: "left",
          width: 150,
          sortable: false,
        },
        {
          text: "Lottable06",
          value: "lottable06",
          sortable: false,
          class: "body-1 font-weight-bold",
        },
        {
          text: "Lottable07",
          value: "lottable07",
          sortable: false,
          class: "body-1 font-weight-bold",
        },
        {
          text: "Lottable08",
          value: "lottable08",
          sortable: false,
          class: "body-1 font-weight-bold",
        },
        {
          text: "Lottable09",
          value: "lottable09",
          sortable: false,
          class: "body-1 font-weight-bold",
        },
        {
          text: "Lottable10",
          value: "lottable10",
          sortable: false,
          class: "body-1 font-weight-bold",
        },
        {
          text: "Created At",
          value: "created_at",
          class: "body-1 font-weight-bold",
          align: "left",
          width: 150,
          sortable: false,
        },
        {
          text: "Updated At",
          value: "updated_at",
          class: "body-1 font-weight-bold",
          align: "left",
          width: 150,
          sortable: false,
        },
      ],
      infor_storer_id: null,
      warehouse_name: null,
      storer_name: null,
      allocation_filter: null,
      stores: [],
      date: null,
      dateMenu: false,
      page: "listPage",
      clients: [],
      selectedClient: null,
      total: 0,
      productsLoader: false,
      file: null,
      fileLoader: false,
      dialog: false,
      statusType: null,
      downloader: false,
      uploadRes: {},
      clientLoader: false,
      isFlag: false,
      value: "",
      warehouses: [],
      order_no: "",
      name: null,
      phone: "",
      email: "",
      address1: "",
      address2: "",
      ErrorMessage: [],
      newTemplate: null,
      help_text: [],
      allocationfilters: [
        {
          text: "NORMAL",
          value: "NORMAL",
        },
        {
          text: "LPN/Pallet ID",
          value: "IDREQUIRED",
        },
        {
          text: "ASN (Lottable02)",
          value: "LOTTABLE02",
        },
        {
          text: "BOE (Lottable03)",
          value: "LOTTABLE03",
        },
        {
          text: "Mfg Date (Lottable04)",
          value: "LOTTABLE04",
        },

        {
          text: "Expiry Date (Lottable05)",
          value: "LOTTABLE05",
        },
        {
          text: "Batch (Lottable06)",
          value: "LOTTABLE06",
        },
        {
          text: "Lottable07",
          value: "LOTTABLE07",
        },
        {
          text: "Lottable08",
          value: "LOTTABLE08",
        },
        {
          text: "Lottable09",
          value: "LOTTABLE09",
        },
        {
          text: "Lottable10",
          value: "LOTTABLE10",
        },
      ],
      editable: false,
      errorFound: false,
    };
  },
  created() {
    if (this.$store.getters.user.user_category == 1) {
      this.selectedClient = this.$store.getters.user.id;
    }
    if (this.$route.query.key > 0) {
      this.editable = true;
      this.getDetailOutbound(this.$route.query.key)
        .then((response) => {
          this.OutboundOrder = response.data.result2.items;

          this.infor_storer_id = response.data.result.channel_id;
          this.selectedClient = response.data.result.client_id;
          this.client_name = response.data.result.client_id__name;
          this.warehouse_name = response.data.result.warehouse_id__name;
          this.storer_name = response.data.result.channel_id__channel_name;
          this.order_no = response.data.result.receipt_no;
          this.date = response.data.result.delivery_date;
          this.expected_receipt_date = response.data.result.receipt_date;
          this.warehouse = response.data.result.warehouse_id;
          const allocation_filter = this.allocationfilters.find((item) => {
            return (
              item.value ===
              response.data.result.inforoutboundskutemp__allocation_strategy
            );
          });
          if (allocation_filter) {
            this.allocation_filter_show = allocation_filter.text;
          }
          this.allocation_filter =
            response.data.result.inforoutboundskutemp__allocation_strategy;
          this.getTemplate(
            response.data.result.inforoutboundskutemp__allocation_strategy
          );
          this.help_text = response.data.help_text;
        })
        .catch((e) => {
          if (e.status_code == 400) {
            this.errorFound = true;
          }
        });
    } else {
      this.getwarehouse();
    }
    // this.getInforWarehouseList().then((response) => {
    //   this.warehouses = response.data.result;
    // });
  },
  methods: {
    ...mapActions([
      "downloadOutoundOrderTemplate",
      "uploadoutboundList",
      "fetchClient",
      "snackBar",
      "getInforWarehouseList",
      "downloadFlagFalse",
      "getWarehouseStores",
      "getDetailOutbound",
      "getOutboundSettings",
      "updateOutboundList",
    ]),

    downloadTemplate() {
      this.downloader = true;
      let url = `/api/file_download?file_path=fulfillmentb2b/${this.newTemplate}`;
      this.downloadOutoundOrderTemplate(url)
        .then((res) => {
          this.fileDownload(res);
          this.downloader = false;
        })
        .catch(() => {
          this.downloader = false;
        });
    },
    getTemplate(filter) {
      if (this.allocation_filter && this.selectedClient) {
        let payload = {
          allocation_filter: filter,
          client_id: this.selectedClient,
        };
        this.getOutboundSettings(payload).then((response) => {
          this.newTemplate = response.data.excel_name;
        });
      }
    },
    getwarehouse() {
      this.warehouse = "";
      this.infor_storer_id = null;

      this.getInforWarehouseList().then((response) => {
        this.warehouses = response.data.result;
      });
    },
    getStores(client, id) {
      let payload = {
        client_id: client,
        warehouse_id: id,
      };
      if (client)
        this.getWarehouseStores(payload).then((res) => {
          this.stores = res.data;
        });
    },
    upload() {
      if (!this.$refs.form.validate()) return;
      this.fileLoader = true;
      const payload = new FormData();
      if (this.order_no) payload.append("order_no", this.order_no);
      if (this.warehouse) payload.append("warehouse", this.warehouse);
      if (this.name) payload.append("customer_name", this.name);
      if (this.address1) payload.append("address1", this.address1);
      if (this.address2) payload.append("address2", this.address2);
      if (this.phone) payload.append("customer_phone", this.phone);
      if (this.email) payload.append("customer_email", this.email);
      if (this.date) payload.append("delivery_date", this.date);
      if (this.infor_storer_id)
        payload.append("storer_id", this.infor_storer_id);
      if (this.allocation_filter)
        payload.append("allocation_filter", this.allocation_filter);

      if (this.file) payload.append("data_file", this.file, this.file.name);
      if (
        this.userCategory.user_category === 3 ||
        this.userCategory.user_category === 6
      ) {
        payload.append("client_id", this.selectedClient);
      }
      if (this.editable) {
        this.updateOutboundList(payload)
          .then((res) => {
            this.fileLoader = false;

            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.$refs.form.reset();
            this.date = null;
            this.$router.push("/outbound-list");
          })
          .catch(() => {
            this.fileLoader = false;
          });
      } else {
        this.uploadoutboundList(payload)
          .then((res) => {
            this.fileLoader = false;

            this.snackBar({
              color: "success",
              message: res.data.message,
            });
            this.$refs.form.reset();
            this.date = null;
            this.$router.push("/outbound-list");
          })
          .catch(() => {
            this.fileLoader = false;
          });
      }
    },
    close() {
      this.selectedClient = null;
      this.file = null;
      this.fileLoader = false;

      this.$refs.form?.reset();
      this.date = null;
      this.$router.push("/outbound-list");
    },
    fetchClientList() {
      if (
        this.userCategory.user_category === 3 ||
        this.userCategory.user_category === 6
      ) {
        this.clientLoader = true;

        this.fetchClient({
          fields: "id,name",
          pagination: 0,
          service: "b2b_fulfillment",
          active_facility: 1,
          warehouse_id: this.warehouse,
        })
          .then((res) => {
            this.clientLoader = false;
            this.clients = res.data;
          })
          .catch(() => {
            this.clientLoader = false;
          });
      }
    },
    listPage() {
      this.$router.push({
        name: "outboundBulkordersStatusList",
        params: {
          type: "outbound_upload,outbound_bulk_upload",
        },
      });
    },
  },
};
</script>
<style>
.custom .v-text-field {
  padding-top: 0;
}
</style>
